export const DateService = {
  DATE_FORMAT: 'DD.MM.YYYY',
};
